import { Fragment } from "react"
import {
  CurrentMonth,
  MonthGrid,
  HeaderWrapper,
  MonthButton,
  MonthButtonText,
  NavigateButton,
  NavigationButtonWrapper,
} from "./styled"
import dayjs, { Dayjs } from "dayjs"
import { isYearUnder16YearOld } from "./birthdateValidators"
import { FlexBox } from "components/Common/FlexBox"
import LeftIcon from "./Icons/LeftIcon"
import RightIcon from "./Icons/RightIcon"

const YearSelection = ({
  month,
  setMonth,
  onSelectYear,
  value,
}: {
  value?: Dayjs
  month: Dayjs
  setMonth: (month: Dayjs) => void
  onSelectYear: (month: Dayjs) => void
}) => {
  const startYear = Math.floor(month.year() / 10) * 10
  const endYear = startYear + 9
  return (
    <Fragment>
      <HeaderWrapper>
        <CurrentMonth>
          {" "}
          {startYear} - {endYear}
        </CurrentMonth>

        <FlexBox $gap={8}>
          <NavigationButtonWrapper>
            <NavigateButton
              onClick={() => setMonth(month.subtract(10, "year"))}
            >
              <LeftIcon />
            </NavigateButton>
          </NavigationButtonWrapper>

          <NavigationButtonWrapper>
            <NavigateButton onClick={() => setMonth(month.add(10, "year"))}>
              <RightIcon />
            </NavigateButton>
          </NavigationButtonWrapper>
        </FlexBox>
      </HeaderWrapper>

      <MonthGrid>
        {Array.from({ length: 12 }, (_, i) => {
          const year = Math.floor(month.year() / 10) * 10 + i - 1
          const currentMonth = dayjs().year(year).month(month.month())
          const isSelected = !!value && value.isSame(currentMonth, "year")
          const isDisabled = isYearUnder16YearOld(currentMonth.startOf("year"))

          return (
            <MonthButton
              key={i}
              onClick={() => {
                onSelectYear(currentMonth)
              }}
              $isDisabled={isDisabled}
            >
              <MonthButtonText
                $isSelected={isSelected}
                $isDisabled={isDisabled}
                $isNotIn10YearsRange={i === 0 || i === 11}
              >
                {currentMonth.format("YYYY")}
              </MonthButtonText>
            </MonthButton>
          )
        })}
      </MonthGrid>
    </Fragment>
  )
}

export default YearSelection
